import { useRouter as useBaseRouter } from 'next/router';
import { LanguageCode, getSafeLanguageCode } from 'shared/library/i18n/languages';
import { getLanguageCodeFromPath } from 'shared/library/i18n/get-language-code-from-path';

const useRouter = () => {
  const baseRouter = useBaseRouter();

  return {
    pathname: baseRouter.pathname,
    asPath: baseRouter.asPath,
    routePattern: baseRouter.pathname,
    languageCode: (getLanguageCodeFromPath(baseRouter.asPath) ??
      getSafeLanguageCode(baseRouter.locale)) as LanguageCode,
    navigate: baseRouter.push.bind(baseRouter),
    resetTabs: (
      _resets: Record<string, Array<{ name: string; params?: Record<string, unknown> }>>,
      _targetTab: string,
    ) => false,
    push: baseRouter.push.bind(baseRouter),
    back: baseRouter.back.bind(baseRouter),
    replace: baseRouter.replace.bind(baseRouter),
    prefetch: (target: string) => {
      void baseRouter.prefetch(target);
    },
    reload: baseRouter.reload.bind(baseRouter),
    query: baseRouter.query,
    events: baseRouter.events,
  };
};

const useStaticRouter = useRouter;

export { useRouter, useStaticRouter };
